type PendingPostSignupAuthUserId = {
  memberId: string
  authUserId: string
  expiresAt: number
}

const POST_SIGNUP_AUTH_USER_ID_TTL_MS = 60_000

let pendingPostSignupAuthUserId: PendingPostSignupAuthUserId | null = null

export function setPostSignupAuthUserIdBridge(args: {
  memberId: string
  authUserId: string | number
  ttlMs?: number
}): void {
  const memberId = args.memberId.trim()
  const authUserId = String(args.authUserId).trim()

  if (!memberId || !authUserId) {
    pendingPostSignupAuthUserId = null
    return
  }

  pendingPostSignupAuthUserId = {
    memberId,
    authUserId,
    expiresAt: Date.now() + (args.ttlMs ?? POST_SIGNUP_AUTH_USER_ID_TTL_MS),
  }
}

export function clearPostSignupAuthUserIdBridge(): void {
  pendingPostSignupAuthUserId = null
}

export function getPostSignupAuthUserIdBridge(args: {
  memberId: string | null
  jwtAuthUserId: string | null
}): string | null {
  if (!pendingPostSignupAuthUserId) {
    return null
  }

  if (args.jwtAuthUserId) {
    pendingPostSignupAuthUserId = null
    return null
  }

  if (Date.now() >= pendingPostSignupAuthUserId.expiresAt) {
    pendingPostSignupAuthUserId = null
    return null
  }

  if (!args.memberId || args.memberId !== pendingPostSignupAuthUserId.memberId) {
    pendingPostSignupAuthUserId = null
    return null
  }

  return pendingPostSignupAuthUserId.authUserId
}
